module.exports = " <template v-if=\"mode=='cascader'\"> <div :class=classes> <cascader :data=data :value.sync=value :disabled=disabled :clearable=clearable :placeholder=placeholder :size=size :change-on-select=changeOnSelect :render-format=renderFormat :not-found-text=notFoundText></cascader> <div :class=\"[`${formPrefixCls}-error-msg-tip`]\" v-if=\"validateMessage && showMessage\">{{ validateMessage }}</div> </div> </template> <template v-if=\"mode=='text'\"> <span>{{str}}</span> </template> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/xman/xcascader/xcascader.vue
// module id = 314
// module chunks = 0